import { h, Component } from 'preact';

class Barcode extends Component {
  render () {
    const { color, size } = this.props;

    return (
      <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="barcode-icon" fill={color || '#3833EA'} fillRule="nonzero">
            <path d="M2 4h2v16H2V4zm3 0h1v16H5V4zm2 0h2v16H7V4zm3 0h1v16h-1V4zm3 0h1v16h-1V4zm2 0h2v16h-2V4zm3 0h1v16h-1V4zm2 0h2v16h-2V4z" />
          </g>
        </g>
      </svg>
    );
  }
}

export default Barcode;
